var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc33Etc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0677 13.4376V31.5391C35.0677 32.3452 34.4142 32.9987 33.6081 32.9987H14.6328V11.834H33.4641C34.3497 11.834 35.0677 12.552 35.0677 13.4376Z",
    fill: "#E99D05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.7272C9 10.7733 9.77329 10 10.7272 10H29.7799C30.7338 10 31.5071 10.7733 31.5071 11.7272V23.6034L31.4793 26.3887L9 26.324V11.7272Z",
    fill: "#F0F1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.7773H30.6915C31.5772 15.7773 32.2952 16.4953 32.2952 17.381V31.5414C32.2952 32.3475 32.9487 33.001 33.7548 33.001H35.0685L5 33.001V15.7773Z",
    fill: "#FBBD41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.0889H17.8448V13.4378C17.8448 12.5522 17.1268 11.8342 16.2411 11.8342H6.60365C5.71798 11.8342 5 12.5522 5 13.4378V17.0889Z",
    fill: "#FBBD41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc33Etc);
export default __webpack_public_path__ + "static/media/Ic3.3Etc.38b41f9fa78edde8ad84c029bb7214db.svg";
export { ForwardRef as ReactComponent };